import { OrderPostTicketPageViewModel } from "../ViewModels/OrderPostViewModels";

export function normalizeFromBackend(
  page: OrderPostTicketPageViewModel
): OrderPostTicketPageViewModel {
  return {
    ...page,
    orderPosts: page.orderPosts.map(t => ({
      ...t,
      ticketProducts: t.ticketProducts.map(p => {
        const quantity = p.quantity ?? 0;
        const alreadyOrdered = p.orderedQuantity ?? 0; // historikk fra backend
        const baseToOrder = Math.max(0, quantity - alreadyOrdered);
        

        return {
          ...p,
          // behold original backend-felt hvis du vil se det, men vi styrer alt via toOrder/alreadyOrdered
          quantity,
          alreadyOrdered,
          toOrder: baseToOrder,
          orderedQuantity: 0,
        };
      }),
    })),
  };
}
